module.exports = __webpack_public_path__ + "img/art3-img5.e96f8ad4.jpeg";